import { type Price, PriceFromApiSchema } from './price';
import { Schema } from 'effect';

import { CurrencySchema, type CurrencyT } from '../tenant/currency';

export const PriceWithCurrencySchema = Schema.Struct({
  price: PriceFromApiSchema,
  currency: CurrencySchema,
}).pipe(Schema.annotate({ identifier: 'PriceWithCurrency' }));

export type PriceWithCurrency = Schema.Schema.Type<typeof PriceWithCurrencySchema>;
export type PriceWithCurrencyEncoded = Schema.Codec.Encoded<typeof PriceWithCurrencySchema>;

export const makePriceWithCurrency = (price: Price, currency: CurrencyT): PriceWithCurrency => ({
  price,
  currency,
});

export const decodeUnknownPriceWithCurrencySync = Schema.decodeUnknownSync(PriceWithCurrencySchema);
